import React, { useState, useEffect, useMemo } from "react";
import { useTeamUsersQueries } from "../../store/teams/teamsQueries";
import StudentTable from "../../shared/components/Table/StudentTable";
import Pagination from "../../shared/components/Pagination/Pagination";
import search_icon from "../../assets/images/search_icon.svg";
import loader from "../../assets/gifs/loader.gif";
import { CONFIG_VARS } from "../../constants/urlConstants/configuration";

const TeamsAllUsersTabContent = () => {
  const {
    agents: users,
    totalCount,
    currentPage,
    itemsPerPage,
    isLoading,
    error,
    handlePageChange,
    handleLimitChange,
    handleSearchQueryChange,
  } = useTeamUsersQueries(1, 50);

  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      handleSearchQueryChange(searchInput);
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [searchInput, handleSearchQueryChange]);

  const handleSearch = (e) => {
    setSearchInput(e.target.value);
  };

  const processedUsers = useMemo(() => {
    if (!users) return [];
    const roleIdToNameMap = Object.entries(CONFIG_VARS.roleMappings[1]).reduce(
      (acc, [id, name]) => {
        acc[id] = name;
        return acc;
      },
      {}
    );

    return users.map((user) => {
      const roleIds =
        user.roles && user.roles.length > 0 ? [...user.roles].sort() : [];
      const roleNames = roleIds
        .map((id) => roleIdToNameMap[id] || "Unknown Role")
        .join(", ");
      const roleIdsString = roleIds.join(", ");

      return {
        ...user,
        role_id: roleIdsString,
        role_name: roleNames,
      };
    });
  }, [users]);

  const columns = [
    { key: "first_name", label: "FIRST NAME" },
    { key: "last_name", label: "LAST NAME" },
    { key: "crn_id", label: "CRN ID" },
    { key: "phone", label: "PHONE" },
    { key: "role_name", label: "ROLE NAME" },
    { key: "role_id", label: "ROLE ID" },
  ];

  if (error) {
    return (
      <div className="error-message">
        Error loading users: {error.message || "Unknown error"}
      </div>
    );
  }

  return (
    <div className="teams-users-tab-content">
      <div className="filters-wrapper">
        <div className="search-wrapper">
          <img src={search_icon} alt="Search" className="search-icon" />
          <input
            type="text"
            placeholder="Search users..."
            value={searchInput}
            onChange={handleSearch}
            className="schools-search-input"
          />
        </div>
        <Pagination
          totalItems={totalCount}
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
          itemsPerPageOptions={[50, 100, 500, 1000]}
          onPageChange={handlePageChange}
          onItemsPerPageChange={handleLimitChange}
        />
      </div>
      <div className="tableCont">
        {isLoading ? (
          <div className="loaderCont">
            <img
              src={loader}
              alt="Loading..."
              style={{
                width: "300px",
                height: "300px",
                margin: "auto",
                display: "block",
              }}
            />
          </div>
        ) : (
          <StudentTable
            data={processedUsers}
            columns={columns}
            showRowSelector={false}
          />
        )}
      </div>
    </div>
  );
};

export default TeamsAllUsersTabContent;
